var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-exchange"},[_c('exchange-form',{attrs:{"currencies":_vm.currencies},on:{"on-update-form":_vm.calculate,"on-reset-results":_vm.resetResults}}),_c('exchange-results',{attrs:{"results":_vm.results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }